import { Button, DialogActions } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { I18n } from 'aws-amplify';

export default function ReactionErrorDialog(props) {
    const { isOpen, setIsOpen, reactionErrorMsg, setReactionErrorMsg } = props;

    const onCloseDialog = (event, reason) => {
        if (event && reason === 'backdropClick') {
            return false;
        }
        setIsOpen(false);
    };

    const onClickBtnConfirm = () => {
        setIsOpen(false);
        setReactionErrorMsg('');
    };

    return (
        <Dialog
            open={isOpen}
            onClose={(event, reason) => onCloseDialog(event, reason)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="wrapDialog"
        >
            <DialogContent>
                <div className="confirmPlease">
                    {/* Message Confirm */}
                    {I18n.get(reactionErrorMsg)}
                </div>
            </DialogContent>
            <DialogActions className="confirm-dialog-action">
                <Button
                    variant="contained"
                    className="btn-hg32 btn-handle-delete-user-agree"
                    onClick={onClickBtnConfirm}
                >
                    {/* OK */}
                    {I18n.get('COMBTN006')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
